(function () {
  'use strict';

  var accountPath = /^\/(?:(?:[a-z]{2}(?:-[a-z]{2})?)\/)?a\/account\/(?:loyalty|login)\/?$/i;
  var authIntentKey = 'beefcakeClubAuthIntent';
  var authIntentMaxAge = 30 * 60 * 1000;
  if (!accountPath.test(window.location.pathname)) return;

  if (!document.querySelector("link[href*='beefcake-account-loyalty.css']")) {
    var accountLoyaltyScript = document.currentScript;
    if (accountLoyaltyScript && accountLoyaltyScript.src) {
      var accountLoyaltyStylesheet = document.createElement('link');
      accountLoyaltyStylesheet.rel = 'stylesheet';
      accountLoyaltyStylesheet.href = accountLoyaltyScript.src.replace(
        /beefcake-account-loyalty\.js(?:\?[^#]*)?/,
        'beefcake-account-loyalty.css'
      );
      document.head.appendChild(accountLoyaltyStylesheet);
    }
  }

  function enhanceAccountLoginFields() {
    document.querySelectorAll('#MainContent input[type="email"][name="email"]').forEach(function (input) {
      input.autocomplete = 'email';
      input.autocapitalize = 'none';
      input.autocorrect = 'off';
      input.spellcheck = false;
      input.placeholder = 'Your email…';
      input.style.minHeight = '44px';
    });
  }

  function publishDashboardView() {
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?a\/account\/loyalty\/?$/i.test(window.location.pathname)) return;
    if (document.documentElement.hasAttribute('data-bc-dashboard-view-sent')) return;

    document.documentElement.setAttribute('data-bc-dashboard-view-sent', 'true');
    var detail = {
      event: 'club_dashboard_view',
      page_path: window.location.pathname,
      context: 'account_loyalty'
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({}, detail));
    document.dispatchEvent(new CustomEvent('beefcake:club-event', { detail: detail }));
  }

  function publishAuthComplete() {
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?a\/account\/loyalty\/?$/i.test(window.location.pathname)) return;

    try {
      var storedIntent = window.sessionStorage.getItem(authIntentKey);
      if (!storedIntent) return;

      var authIntent;
      try {
        authIntent = JSON.parse(storedIntent);
      } catch (parseError) {
        authIntent = { intent: storedIntent === 'club_join_click' ? 'join' : 'sign_in' };
      }

      if (!authIntent || typeof authIntent !== 'object') {
        authIntent = { intent: authIntent === 'club_join_click' ? 'join' : 'sign_in' };
      }

      window.sessionStorage.removeItem(authIntentKey);
      if (
        authIntent.created_at &&
        Date.now() - authIntent.created_at > authIntentMaxAge
      ) return;

      var detail = {
        event: 'club_auth_complete',
        page_path: window.location.pathname,
        method: authIntent.intent === 'join' ? 'join' : 'sign_in',
        placement: authIntent.placement || undefined,
        source_path: authIntent.source_path || undefined
      };

      Object.keys(detail).forEach(function (key) {
        if (detail[key] === undefined) delete detail[key];
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({}, detail));
      document.dispatchEvent(new CustomEvent('beefcake:club-event', { detail: detail }));
    } catch (error) {
      // Authentication stays successful when browser storage is unavailable.
    }
  }

  function initializeAccountExperience() {
    enhanceAccountLoginFields();
    publishAuthComplete();
    publishDashboardView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccountExperience, { once: true });
  } else {
    initializeAccountExperience();
  }

  // The account app can hydrate its sign-in field after DOMContentLoaded. This
  // observer only reapplies native input attributes; it never inspects or
  // rewrites Skio's private component tree, reward copy, or completion state.
  var mainContent = document.querySelector('#MainContent');
  if (mainContent) {
    var inputUpdateQueued = false;
    var observer = new MutationObserver(function () {
      if (inputUpdateQueued) return;
      inputUpdateQueued = true;
      window.requestAnimationFrame(function () {
        inputUpdateQueued = false;
        enhanceAccountLoginFields();
      });
    });
    observer.observe(mainContent, { childList: true, subtree: true });
  }
})();
